<template>
  <div class="flex mb-12 bulk-quiz-form">
    <div class="w-3/5 content-left-panel">
      <div class="flex flex-wrap mt-10">
        <upload-file
          automatic
          class="w-full pl-0"
          text="Bulk Quiz creation and update by CSV"
          @on-success="successUpload"
          @on-error="errorUpload"
          :uploadMethod="uploadQuizCSVWrapper"
        />
        <small class="ml-3">Choose a file, this will be uploaded automatically</small>
      </div>

      <div class="bulk-results" v-if="responseToShow">
        <h4 class="mt-10 mb-5">Upload Results</h4>
        <ul class="flex w-full flex-wrap" v-if="responseToShow.results">
          <li class="mt-5 w-1/3">
            Quizzes created: <strong>{{responseToShow.results.quizzes.created.length}}</strong> <br/>
            Quizzes updated: <strong>{{responseToShow.results.quizzes.updated.length}}</strong>
          </li>
          <li class="mt-5 w-1/3">
            Questions created: <strong>{{responseToShow.results.questions.created.length}}</strong> <br/>
            Questions updated: <strong>{{responseToShow.results.questions.updated.length}}</strong>
          </li>
          <li class="mt-5 w-1/3">
            Answers created: <strong>{{responseToShow.results.answers.created.length}}</strong> <br/>
            Answers updated: <strong>{{responseToShow.results.answers.updated.length}}</strong>
          </li>
        </ul>
        <vs-divider/>

        <div class="flex items-center justify-between mb-5">
          <h4>List of quizzes</h4>
          <vs-button
            v-if="placeableQuizMappings.length"
            color="primary"
            type="border"
            icon="place"
            :disabled="placingQuizzes"
            @click="placeQuizzesInCourses"
          >
            {{ placingQuizzes ? 'Placing quizzes…' : 'Place Quizzes in Courses' }}
          </vs-button>
        </div>

        <ul class="w-full" v-if="responseToShow.mapping">
          <li class="mb-5" v-for="quiz in responseToShow.mapping" :key="quiz.quiz_uuid">
            <div class="flex items-center flex-wrap gap-2">
              <router-link :to="{name: 'edit-quiz', params: {id: quiz.quiz_uuid}}">{{quiz.quiz_uuid}}</router-link>
              <vs-chip v-if="!quiz.video_id" color="warning" class="m-0">no video match</vs-chip>
            </div>
            <small class="text-grey">{{quiz.video_reference}}</small>
          </li>
        </ul>
      </div>

      <div class="placement-results mt-8" v-if="placementResponse">
        <vs-divider/>
        <h4 class="mb-5">Course Placement Results</h4>
        <ul class="flex w-full flex-wrap mb-5">
          <li class="w-1/2">
            Quizzes placed: <strong>{{placementResponse.inserted.length}}</strong>
          </li>
          <li class="w-1/2">
            Skipped: <strong>{{placementResponse.skipped.length}}</strong>
          </li>
        </ul>

        <div v-if="placementResponse.inserted.length">
          <p class="mb-2 font-semibold">Placed:</p>
          <ul class="w-full">
            <li class="mb-3" v-for="item in placementResponse.inserted" :key="item.quiz_id">
              Quiz <strong>{{item.quiz_id}}</strong> placed in {{item.courses_updated.length}} {{item.courses_updated.length === 1 ? 'course' : 'courses'}}:
              <ul class="mt-1 ml-4">
                <li class="text-grey text-sm" v-for="course in item.courses_updated" :key="course.id">
                  {{course.name}} <span class="text-xs">({{course.id}})</span>
                </li>
              </ul>
            </li>
          </ul>
        </div>

        <div v-if="placementResponse.skipped.length" class="mt-4">
          <p class="mb-2 font-semibold">Skipped:</p>
          <ul class="w-full">
            <li class="mb-2" v-for="item in placementResponse.skipped" :key="item.quiz_id">
              Quiz <strong>{{item.quiz_id}}</strong> — {{item.reason}}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="w-2/5 pl-10 content-right-panel">
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import UploadFile from "../components/UploadFile";

export default {
  components: {
    UploadFile
  },
  data: () => ({
    responseToShow: null,
    placementResponse: null,
    placingQuizzes: false,
  }),
  computed: {
    placeableQuizMappings() {
      if (!this.responseToShow || !this.responseToShow.mapping) return []
      return this.responseToShow.mapping
        .filter(q => q.video_id)
        .map(q => ({ quiz_id: q.quiz_uuid, video_id: q.video_id }))
    }
  },
  methods: {
    ...mapActions('quizzes', ['uploadQuizCSV', 'insertQuizzesAfterVideos']),
    errorUpload(error) {
      this.showError(error)
    },
    successUpload() {},
    async uploadQuizCSVWrapper(formData) {
      try {
        this.$vs.loading()
        const response = await this.uploadQuizCSV(formData)
        this.responseToShow = response
        this.placementResponse = null

        this.$vs.notify({
          color: 'success',
          title: 'Upload Success',
          text: 'The file was uploaded successfully'
        })

        if (this.placeableQuizMappings.length) {
          await this.placeQuizzesInCourses()
        }
      } catch (error) {
        this.showError(error)
      }
      this.$vs.loading.close()
    },
    async placeQuizzesInCourses() {
      try {
        this.placingQuizzes = true
        const result = await this.insertQuizzesAfterVideos(this.placeableQuizMappings)
        this.placementResponse = result

        this.$vs.notify({
          color: 'success',
          title: 'Placement Complete',
          text: `${result.inserted.length} ${result.inserted.length === 1 ? 'quiz' : 'quizzes'} placed in courses`
        })
      } catch (error) {
        this.showError(error)
      }
      this.placingQuizzes = false
    }
  }
}
</script>

<style lang="scss">
.bulk-quiz-form {
  .content-left-panel {
    .con-img-upload {
      .img-upload {
        height: 100px;
        width: 100px;
      }
      .text-archive {
        font-size: 0.8em;
      }
    }
    .con-input-upload {
      margin: 0;
      width: 100%;
      height: 100px;
    }
  }
}
</style>
